import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {AddBookForm} from "../../../components/publisher/my-books/add-book/add-book-form";
import {DetailsWrapper} from "../../../components/details-wrapper/details-wrapper";
import {useParams} from "react-router-dom";
import {toggleLoader} from "../../../store/global/global-slice";
import {PublisherService} from "../../../services/publisher.service";
import {PublisherBookModel} from "../../../models/publisher/publisher-book.model";
import {useDispatch} from "react-redux";

const PublisherMyBookEditPage = () => {
	const [book, setBook] = React.useState<PublisherBookModel>(null);
	const { t } = useTranslation('publisher');
	const urlParams = useParams();
	const dispatch = useDispatch();
	const id: string = urlParams['id'] as string;

	useEffect(() => {
		const loadBook = async (id: string) => {
			dispatch(toggleLoader(true));

			const bookTmp = await PublisherService.getBook(id);
			setBook(bookTmp);

			dispatch(toggleLoader(false));
		}

		if (id) {
			loadBook(id);
		}
	}, [id, dispatch]);


	return (
		<DetailsWrapper description={t('addBook.pageDesc')}>
			{book &&
                <AddBookForm book={book}/>
			}
		</DetailsWrapper>
	)
}

export default PublisherMyBookEditPage;
